import { SubscriptionCharge } from '../../../../models/subscription/types';

export type Args = {
  isPastRenewalDate: boolean;
  resumeOption: 'immediate' | 'automatic_resume';
  resumptionConfig?: SubscriptionCharge;
};

export const getSubscriptionResumeAlertKeys = ({
  isPastRenewalDate,
  resumeOption,
  resumptionConfig,
}: Args) => {
  const accessDateInfo =
    resumeOption === 'immediate'
      ? 'resume_subscription.regain_access'
      : 'resume_subscription.regain_access_on_selected_date';

  const chargeInfo = getChargeInfoKey(resumptionConfig, isPastRenewalDate);

  return {
    accessDateInfo,
    chargeInfo,
  };
};

const getChargeInfoKey = (
  resumptionConfig: SubscriptionCharge,
  isPastRenewalDate: boolean
) => {
  if (!resumptionConfig) {
    if (isPastRenewalDate) {
      return 'resume_subscription.immediate_charge';
    }
    return 'resume_subscription.no_immediate_charges';
  }
  switch (resumptionConfig) {
    case 'prorated':
      return 'resume_subscription.immediate_prorated_charge';
    case 'immediate':
      return 'resume_subscription.immediate_charge';
    case 'delayed':
      return 'resume_subscription.delayed_charge';
  }
};
